
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevCard } from '@ds/components/Card'
import { RevDivider } from '@ds/components/Divider'
import { RevIllustration } from '@ds/components/Illustration'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { RevList } from '@ds/components/List'
import { RevListItem } from '@ds/components/ListItem'
import { IconChevronDown } from '@ds/icons/IconChevronDown'
import { IconChevronUp } from '@ds/icons/IconChevronUp'
import { IconLeaf } from '@ds/icons/IconLeaf'
import { IconMoney } from '@ds/icons/IconMoney'
import { IconPackage } from '@ds/icons/IconPackage'
import { IconShoppingBag } from '@ds/icons/IconShoppingBag'

import Faq from '@buyback/customer/swap/components/Faq'
import ProductInfo from '@buyback/shared/components/ProductInfo'

import translations from './Offer.translations'
import { CATEGORIES } from './constants'

export default {
  components: {
    ProductInfo,
    RevIllustration,
    RevButtonBase,
    RevList,
    RevListItem,
    RevCard,
    RevDivider,
    RevInfoBlock,
    IconShoppingBag,
    IconPackage,
    IconMoney,
    IconChevronDown,
    IconChevronUp,
    Faq,
  },
  props: {
    offer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isPanelOpen: false,
    }
  },
  computed: {
    translations: () => translations,
    IconLeaf: () => IconLeaf,
    details() {
      return this.offer?.diagnostic_summary
    },
    title() {
      return this.offer?.title
    },
    imageUrl() {
      return this.offer?.thumbnail
    },
    price() {
      return this.$t.price(this.offer?.standard_price)
    },
    ewasteEstimationTitle() {
      const EWASTE_CATEGORIES_TITLE = {
        [CATEGORIES.SMARTPHONE]: this.$t(translations.ewasteSmartphone),
        [CATEGORIES.MACBOOK]: this.$t(translations.ewasteMacbook),
        [CATEGORIES.TABLET]: this.$t(translations.ewasteMacbook),
        [CATEGORIES.CONSOLE]: this.$t(translations.ewasteConsole),
        [CATEGORIES.AUDIO]: this.$t(translations.ewasteAudio),
      }
      const category = this.offer?.diagnostic_payload?.category

      return this.$t(translations.infoBlockTitle, {
        weight: EWASTE_CATEGORIES_TITLE[category],
      })
    },
  },
  methods: {
    togglePanel() {
      this.isPanelOpen = !this.isPanelOpen
    },
  },
}
